export class Events {
    
    public static readonly STOP_SPINNING = "stop spinning";
    
    private type: string;
    private params: any;

    constructor(type: string, params?: any) {

        this.type = type;
        this.params = params || null;
    }

    public getParams(): any {

        return this.params;
    }

    public getType(): string {
        
        return this.type;
    }
}
